import { getProductFormField } from '../utils';
import Component from './ProductFormMultiCheckbox';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
